export function storeSlugForCoupon(coupon) {
  if (!coupon) return "";
  if (coupon.storeSlug) return coupon.storeSlug;
  if (coupon.storeName) {
    return String(coupon.storeName)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "")
      .replace(/^-+|-+$/g, "");
  }
  return "";
}
